import { render, staticRenderFns } from "./reportDetailLow.vue?vue&type=template&id=e2109ad8&scoped=true&"
import script from "./reportDetailLow.vue?vue&type=script&lang=js&"
export * from "./reportDetailLow.vue?vue&type=script&lang=js&"
import style0 from "./reportDetailLow.vue?vue&type=style&index=0&id=e2109ad8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2109ad8",
  null
  
)

export default component.exports